import Step9 from './Step9-compose';

export default Step9;
